import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Button, IconButton, Menu, MenuItem } from '@mui/material'
import { useAuth } from '../auth/AuthProvider'
import { Icona, Marchio } from './Marchio'
import { ICONE } from './icone'

const MENU = 'M4 7h16M4 12h16M4 17h16'

const AIUTO = [
  { etichetta: 'Guide e tutorial', rotta: 'guide' },
  { etichetta: 'Funzionalità', rotta: 'funzionalita' },
  { etichetta: 'Assistenza', rotta: 'helpdesk' },
]

export function BarraSuperiore({ onMenu }: { onMenu?: () => void }) {
  const { sessione, esci } = useAuth()
  const { idPartner } = useParams()
  const email = sessione?.user.email ?? ''
  const [ancora, setAncora] = useState<HTMLElement | null>(null)

  return (
    <header className="barra-superiore">
      {onMenu && (
        <IconButton className="barra-menu" onClick={onMenu} aria-label="Apri o chiudi il menu">
          <Icona d={MENU} />
        </IconButton>
      )}
      <Marchio />
      <span className="barra-utente">{email}</span>
      <IconButton className="barra-aiuto" aria-label="Aiuto" aria-haspopup="menu" onClick={(e) => setAncora(e.currentTarget)}>
        <Icona d={ICONE.aiuto} />
      </IconButton>
      <Menu anchorEl={ancora} open={ancora !== null} onClose={() => setAncora(null)}>
        {AIUTO.map((a) => (
          <MenuItem key={a.rotta} component={Link} to={`/cliente/${idPartner}/${a.rotta}`} onClick={() => setAncora(null)}>
            {a.etichetta}
          </MenuItem>
        ))}
      </Menu>
      <Button variant="outlined" size="small" onClick={() => void esci()}>
        Esci
      </Button>
    </header>
  )
}
